import api from '@/api';

export default {
	state: {
		schools: null
	},
	mutations: {
	},
	actions: {
	}
};



// WEBPACK FOOTER //
// ./src/store/schools/index.js